export enum types {
  UPDATE_FORMDATA = 'UPDATE_FORMDATA',
  OPEN_IMAGES = 'OPEN_IMAGES',
  OPEN_STYLESHEET = 'OPEN_STYLESHEET',
}
